import Vue from 'vue';
import moment from 'moment-timezone';

import state from '../state';

Vue.filter('date', function(date) {
    if (!date) return '';
    var mdate = moment.tz(date, state.adminTimezone.get().id);
    if (mdate.isSame(new Date(), 'year')) {
        return mdate.format('D MMM');
    }
    return mdate.format('D MMM YYYY');
});



// WEBPACK FOOTER //
// ./src/filters/date.filter.js